export default function inputNumberIsEmpty(value: number | null | undefined): boolean {
    if (value === null) {
        return true;
    }

    return value === 0;
}
